import React, { PureComponent } from 'react'
import { Jumbotron } from 'reactstrap'
import { getDecodedToken } from 'helpers'

class Home extends PureComponent {
    render() {
        const user = getDecodedToken()
        return (
            <div className="container">
                <div className="row mt-5">
                    <div className="col">
                        <Jumbotron>
                            <h4 className="align-middle">Bem vindo(a) {user.nome}</h4>
                            <p>Utilize o menu ao lado para acessar os recursos do sistema.</p>
                        </Jumbotron>                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Home